const monthlyPayment = (
  principal: number,
  annualRateInDecimal: number,
  numberOfPayments: number,
) => {
  if (annualRateInDecimal === 0) {
    return principal / numberOfPayments;
  }
  const P = principal;
  const r = annualRateInDecimal / 12; // monthly rate
  const n = numberOfPayments;

  return (P * r * Math.pow(1 + r, n)) / (Math.pow(1 + r, n) - 1);
};

export { monthlyPayment };
